import router from "./router";
import getPageTitle from "./utils/get-page-title";
router.beforeEach(async (to, from, next) => {
  getPageTitle(to.meta.title);
  // // 页面标题
  // document.title = to.meta.title;
  next();
});
